var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rule-form',{attrs:{"rule-id":_vm.ruleId,"transaction-type":_vm.transactionType}})
}
var staticRenderFns = []

export { render, staticRenderFns }